import React from "react";
import styles from "./FourZeroFour.module.scss";

const FourZeroFour = () => {
  return (
    <main className={styles.fourZeroFour}>
      <div>ERROR 404</div>
      <div>PAGE NOT FOUND</div>
    </main>
  );
};

export default FourZeroFour;
